import { useQuery } from '@tanstack/react-query'
import { useAuth as useOidcAuth } from 'react-oidc-context'

import { getMeUsersMeGetOptions } from 'src/api/intranet'

export const useCurrentUser = () => {
  const { isAuthenticated } = useOidcAuth()

  return useQuery({
    ...getMeUsersMeGetOptions(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000
  })
}
